// src/constants.ts
var UNKNOWN_TOKEN = { exp: 0, iat: 0, sub: "", typ: "UNKNOWN", org: "", rol: [] };
var TO_MILLI_SECONDS = 1e3;
var STORAGE_KEY = `auth-tokens-${process.env.NODE_ENV}`;
var DREAMDATA_USER_ID = "ajs_user_id";
var DREAMDATA_ANOUNYMOUS_USER_ID = "dd_anonymous_id";

// src/utils/cookiesUtils.ts
var readCookie = (name) => {
  const nameEq = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(nameEq) === 0) {
      return decodeURIComponent(cookie.substring(nameEq.length, cookie.length));
    }
  }
  return null;
};

// src/utils/jwtUtils.ts
function jwtDecode(jwtToken) {
  let parsedPayload;
  if (!jwtToken) {
    return UNKNOWN_TOKEN;
  }
  try {
    const encodedPayload = jwtToken.split(".")[1];
    parsedPayload = JSON.parse(window.atob(encodedPayload));
  } catch (e) {
    parsedPayload = UNKNOWN_TOKEN;
  }
  return parsedPayload;
}

// src/utils/tokenUtils.ts
import store from "store2";
var getRefreshToken = () => {
  const tokens = getAuthTokens();
  return tokens ? tokens.refreshToken : void 0;
};
var getAccessToken = () => {
  const tokens = getAuthTokens();
  return tokens ? tokens.accessToken : void 0;
};
var getAuthTokens = () => {
  const rawTokens = store.local.get(STORAGE_KEY);
  if (!rawTokens) {
    return void 0;
  }
  return rawTokens;
};
function getNonExpiredToken(token) {
  if (!token) {
    return null;
  }
  const { exp } = jwtDecode(token);
  const isTokenExpired = Date.now() > exp * TO_MILLI_SECONDS;
  return isTokenExpired ? null : token;
}
var getActiveToken = () => {
  const accessToken = getAccessToken();
  const validAccessToken = getNonExpiredToken(accessToken);
  if (validAccessToken) {
    return validAccessToken;
  }
  const refreshToken = getRefreshToken();
  const validRefreshToken = getNonExpiredToken(refreshToken);
  if (validRefreshToken) {
    return validRefreshToken;
  }
  return null;
};

// src/utils/index.ts
function getTrackingDataFromToken() {
  const token = getActiveToken();
  if (!token) {
    return {
      isLoggedIn: false,
      orgId: null,
      userId: null
    };
  }
  const payload = jwtDecode(token);
  return {
    isLoggedIn: true,
    orgId: payload.org || null,
    userId: payload.sub || null
  };
}
var getDreamDataUserId = () => {
  if (typeof window === void 0) {
    return null;
  }
  return readCookie(DREAMDATA_USER_ID) || readCookie(DREAMDATA_ANOUNYMOUS_USER_ID);
};

// src/methods/trackEvent.ts
function trackEvent(eventPayload) {
  if (process.env.NODE_ENV !== "production") {
    console.log("trackEvent:", eventPayload);
  }
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
  }
}

// src/methods/track.ts
var transformInteractionType = (type) => {
  const typeMap = {
    click: "dl_click",
    error: "dl_error"
  };
  return typeMap[type];
};
function track(params) {
  const { userId, isLoggedIn, orgId } = getTrackingDataFromToken();
  const ddUserId = getDreamDataUserId() || "";
  const url = window.location.href;
  const path = window.location.pathname;
  const user = {
    status: isLoggedIn ? "loggedIn" : "guest",
    userId,
    organizationId: orgId,
    dd_user_id: ddUserId
  };
  const page = {
    url,
    path,
    domainCountry: params.page.domainCountry,
    type: params.page.type,
    details: params.page.details ? JSON.stringify(params.page.details) : void 0
  };
  switch (params.event) {
    case "interaction": {
      const { interaction } = params;
      const transformedEvent = {
        event: "interaction",
        user,
        page,
        interaction: {
          type: transformInteractionType(interaction.type),
          element: interaction.element,
          elementText: interaction.elementText ?? event?.target?.textContent ?? "",
          location: interaction.location ?? interaction.element,
          detail: JSON.stringify(interaction.detail) ?? ""
        }
      };
      trackEvent(transformedEvent);
      break;
    }
    case "page_load": {
      trackEvent({
        event: "page_load",
        user,
        page
      });
      break;
    }
    case "form_submission": {
      const { form } = params;
      trackEvent({
        event: "form_submission",
        user,
        page,
        form: {
          formName: form.formName,
          stepName: form.stepName,
          intent: form.intent,
          funnelId: form.funnelId
        }
      });
      break;
    }
    default:
      break;
  }
}
export {
  track
};
//# sourceMappingURL=index.js.map